import React from 'react'
import { Button, Container, Grid, Typography } from "@mui/material";
import { ArrowForward as ArrowForwardIosIcon } from "@mui/icons-material";
import Header from "../../Header";
import Slider from "react-slick";
import SliderImg from "../../../../assets/image/ezgif.com-resize-1.png";
import SliderImg2 from "../../../../assets/image/ezgif.com-resize-2.png";
import SliderImg3 from "../../../../assets/image/ezgif.com-gif-maker-5.png";
import SliderImg4 from "../../../../assets/image/ezgif.com-gif-maker-1-1.png";
import SliderImg5 from "../../../../assets/image/jjjjlogo.png";
import SliderImg6 from "../../../../assets/image/ezgif.com-gif-maker-10.png";
import SliderImg7 from "../../../../assets/image/ezgif.com-gif-maker-6.png";
import OurTeamImg from "../../../../assets/image/img_box_24.png";
import OurTeamImg2 from "../../../../assets/image/img_box_25.png";
import OurTeamImg3 from "../../../../assets/image/img_box_26.png";
import OurTeamImg4 from "../../../../assets/image/img_box_27.png";
import OurTeamBgImg from "../../../../assets/image/SMM_bg__img-scaled.png";
import FooterSvg from "../../../../assets/image/Untitled-3.svg";
import LogoIdea from "../../../../assets/image/logo-ideas.png";
import LogoDesign from "../../../../assets/image/logo-design.png";
import LogoEditTool from "../../../../assets/image/logo-editing-tool.png";

import "./WebDesign.css";
import Footer from "../../Footer";

const LogoDesignService = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 9,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const ourTeamGridData = [
    {
      id: 1,
      imgSrc: OurTeamImg,
      color: "#695ce8",
      title: "Website Design and Development",
      description:
        "We provide robust PHP web development services to our global clients in UK, USA, and India. Our programmers are well-known for providing custom PHP solutions which are customized to match your unique business requirements.",
    },
    {
      id: 2,
      imgSrc: OurTeamImg2,
      color: "#f47514",
      title: "Web Portal Development",
      description: `Our PHP website programmers are experts in providing CRM solutions and developing custom features from scratch. Our PHP Development agency ensures that our CRM functionality works perfectly as needed by you.`,
    },
    {
      id: 3,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "Custom Development",
      description: `Our PHP experts offer cloud services like SaaS, LaaS, PaaS and many more backend solution. We provide full stack PHP web development services from initial consultation, to the final PHP application.`,
    },
    {
      id: 4,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Ecommerce Development",
      description: `We provide ecommerce PHP solutions on wordpress, laravel, magento and woocommerce. Our PHP Development company in guwahati  provides full customization services and can help you to add new features to your site .`,
    },
    {
      id: 5,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Support & Maintenance",
      description: `We provide PHP support and maintenance after project completion with 24/7 chat suppport . Our PHP team have worked with small business , large scale enterprise , or any complex business process.`,
    },
    {
      id: 6,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "ERP Solutions",
      description: `As a leading PHP application development company, we offer services like custom ERP development on wordpress, Drupal and WordPress. We create custom ERP which are secure, and fast.`,
    },
  ];

  return (
    <>
    <Header />
    <section>
      <Container>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
            Logo Design Services in Guwahati
            </div>
            <br />
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                textTransform: "uppercase",
                fontWeight: "bold",
                color: "#3a506b",
              }}
            >
             Logo & Corporate
             Identity Design
            </Typography>
            <br />
            <br />
            <img src={LogoIdea} alt='Zoodonix Image' width={400}/>
          </Grid>
          <Grid item xs={12} md={6}>
            <div
              style={{
                textTransform: "uppercase",
                fontWeight: "bold",
                color: "#6254e7",
                paddingTop:'20px'
              }}
            >
              Why Invest in Creative Logo
            </div>
            <h2 className='ts-18'>
            Top Logo Designing Company Specialized to Create Creative Logo.
            </h2>
            <p className='ts-18'>
            Logo is a graphic element which represents a company or brand. This is a way to visually represent a product, service, company, or individual in a way that’s memorable and briefly tells their story. The logo may be only an icon or emblem, or a logotype/wordmark, or combination of both or some image.
            </p>
            <p  className='ts-18'>An effective logo is part of a successful brand, and accordingly, has been strategically created with the same positioning, tone, visual appeal, messaging and story of the brand. Some of the elements used in logo design to communicate this positioning, message and tone are colors, font choice, custom typography or calligraphy, illustration style, shape and style, and historical reference, all of which come together to communicate, for example: rich, organic and home-styled; clean, corporate, strong and efficient; or soft, sensuous and luxurious.</p>
            <Button
                style={{
                  padding: "15px 25px 15px 25px",
                  background: "#6254e7",
                  color: "white",
                  marginBottom: "20px",
                }}
                variant="contained"
                color="#7209b7"
              >
                Explore More
              </Button>
          </Grid>
        </Grid>
      </Container>
    </section>

    <section>
      <Container>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            textTransform: "uppercase",
            fontSize: "17px",
          }}
        >
          <h3 style={{ fontWeight: "bold" }}>Our Happy Clients</h3>
        </div>
        <div className="slider-container">
          <Slider {...settings}>
            <div>
              <img width={70} src={SliderImg} alt="Client 1" />
            </div>
            <div>
              <img width={70} src={SliderImg2} alt="Client 2" />
            </div>
            <div>
              <img width={70} src={SliderImg3} alt="Client 3" />
            </div>
            <div>
              <img width={70} src={SliderImg4} alt="Client 4" />
            </div>
            <div>
              <img width={70} src={SliderImg5} alt="Client 5" />
            </div>
            <div>
              <img width={70} src={SliderImg6} alt="Client 6" />
            </div>
            <div>
              <img width={70} src={SliderImg7} alt="Client 6" />
            </div>
          </Slider>
        </div>
      </Container>
    </section>

    {/* video section  */}

    <section style={{marginTop:'40px'}}>
      <Container>
        <Grid container spacing={0}>
          <Grid item xs={12} md={5}>
            <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
            Trusted Logo Designing Company
            </div>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
            >
              Brochure & Newsletter Design
            </Typography>
            <p className='ts-18'>
            The brochure is one of the best ways to present a company. There are three-fold brochures used to advertise a new product or service that your company offers, or there are two-fold folders that are used to present your company projects outside or inside it. There are different brochure types, and every type has a different way to be designed. The criterion adopted to design a bi-fold brochure to present your company projects for internal use would be different from the one for external use.
            </p>
            <p className='ts-18'>
            Most businesses and organisations need to advertise their services, communicate with their clients or communicate internally with staff. This is where we can help. We have the experience and skills needed to help you create great brochures and newsletters that communicate the message you need
          </p>
          </Grid>
          <Grid item xs={12} md={7}>
            <img src={LogoDesign}  alt='Zoodonixx Image'/>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}></Grid>
          <Grid item xs={12} md={6}>
            <p style={{ textTransform: "uppercase", textAlign: "center" }}>
              Web development services
            </p>
          </Grid>
          
        
        </Grid>
      </Container>
    </section>

    <section
      style={{
        backgroundImage: `url(${OurTeamBgImg})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        padding: "20px",
      }}
    >
      <Container>
        <div style={{ textAlign: "center" }}>
          <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
            Best for you
          </div>
          <Typography
            variant="h5"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#3a506b" }}
          >
            How Our Team Can Help
          </Typography>
          <p style={{ fontSize: "20px" }}>
            We are renowned custom web app development company in <br />{" "}
            Guwahati, offering wide range of web development services <br />{" "}
            that caters to all your business needs:
          </p>
        </div>
        <Grid container spacing={12}>
          {ourTeamGridData.map((item, index) => (
            <Grid item xs={12} md={6} key={item.id}>
              <div style={{ display: "flex", padding: "0px" }}>
                <img
                  src={item.imgSrc}
                  width={50}
                  height={50}
                  alt="Placeholder 1"
                  style={{ marginRight: "10px" }}
                />
                <div>
                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: `${item.color}`,
                    }}
                  >
                    {"0" + item.id}
                    <br />
                    {item.title}
                  </div>
                  <p
                    className="our-team-card-description"
                    style={{
                      fontSize: "18px",
                      color: "#8d99ae",
                      marginTop: "0",
                    }}
                  >
                    {item.description}
                  </p>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>

  
    <section>
      <Container>
        <div
          style={{
            textAlign: "center",
            backgroundImage:
              "linear-gradient(90deg, #56ab2f 0%, #a8e063 100%)",
            padding: "20px",
            color: "#fff",
            borderRadius: "20px",
            boxShadow: "0px 0px 19px 0px rgba(0,0,0,.5)",
          }}
        >
          <p className="text-uppercase text-bold">Welcome</p>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#fff" }}
            className="let-discuss-header"
          >
            Let's Discuss Your Project
          </Typography>
          <p className="let-discuss-para" style={{ fontSize: "18px" }}>
            We accept Mobile Application Development projects including Mobile
            App UI/UX Design from all major towns and cities of Assam
            including Guwahati, Silchar, Dibrugarh, Tezpur, Tinsukia,
            Bongaigaon, Mangaldai, Nalbari, Pathsala, Nagaon, Jorhat,
            Sivasagar, Lakhimpur, Dhekiajuli. We haved expanded our services
            to multiple cities of Northeast including Itanagar, Arunachal
            Pradesh, Imphal, Manipur, Shillong, Meghalaya, Aizawl, Mizoram,
            Agartala, Tripura, Kohima, Nagaland
          </p>
          <Button
            style={{
              padding: "15px 25px 15px 25px",
              background: "#fff",
              color: "black",
              borderRadius: "40px",
            }}
            variant="contained"
            color="#7209b7"
            className="text-uppercase"
          >
            Talk our experts
          </Button>
        </div>
      </Container>
    </section>

    <section>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} style={{marginTop:'30px'}}>
            <p className="text-uppercase text-bold">Analysis</p>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
              className="let-discuss-header"
            >
             We Use the Best Designing Tools
            </Typography>
            <p className="ts-18">
            A logo design software provides various features to create a beautiful and relevant logo for your business. There are a number of logo design software present both free and paid over the internet and you can use them however you like.
            </p>
           
           <div>
            <ul>
              <li className="list-custom-style"><ArrowForwardIosIcon className="arrow-forward-icon" />Adobe Illustrator</li>
              <li  className="list-custom-style"><ArrowForwardIosIcon className="arrow-forward-icon" />Adobe Photoshop</li>
              <li  className="list-custom-style"><ArrowForwardIosIcon className="arrow-forward-icon" />CorelDraw</li>
              <li  className="list-custom-style"><ArrowForwardIosIcon className="arrow-forward-icon" />DesignEvo</li>
              <li  className="list-custom-style"><ArrowForwardIosIcon className="arrow-forward-icon" />GIMP</li>
            </ul>
           </div>
           
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={LogoEditTool} alt="Reseller Bano Key Benefits"/>
          </Grid>
        </Grid>

        
        <img src={FooterSvg} />
      </Container>
    </section>

    <Footer/>
    </>
  )
}

export default LogoDesignService
